<template>
  <img class="flag-icon"
    :src="flagUrl"
    :title="countryName || countryCode || ''"
    :alt="countryName"
    :width="width"
    :height="height"
    @error="onImageError">
</template>

<script>
import { getCdnUrl } from '@/libs/utils'

export default {
  name: 'CountryFlag',
  props: {
    countryCode: {
      type: String,
      default: '',
      required: true
    },
    countryName: {
      type: String
    },
    width: {
      type: Number,
      default: 26
    },
    height: {
      type: Number,
      default: 26
    }
  },
  computed: {
    flagUrl () {
      if (!this.countryCode) {
        return getCdnUrl('/img/flag/etc.png')
      }
      const code = this.countryCode.toLowerCase()
      return getCdnUrl(`/img/flag/${code}.png`)
    }
  },
  methods: {
    onImageError (event) {
      this.flagUrl = getCdnUrl('/img/flag/etc.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.flag-icon {
  vertical-align: middle
}
</style>
